import script from "./AddonCardEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddonCardEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddonCardEdit.vue?vue&type=style&index=0&id=fcefbed2&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcefbed2"]])

export default __exports__